var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "data-load", class: { "sk-loading": _vm.isLoading } },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("pages.permission.data")))]),
      _vm.isLoading ? _c("sk-spinner") : _vm._e(),
      _vm.isInitialized
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col text-right" }, [
              _c(
                "a",
                {
                  staticClass: "portal-back secondary-button",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.goBack.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fas fa-chevron-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _c("span", { staticClass: "back-link" }, [
                    _vm._v(_vm._s(_vm.$t("components.actions.back"))),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.isInitialized && _vm.detail.id
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.absences.id"),
                    value: _vm.detail.id,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isInitialized && _vm.detail.isPermission()
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.status"),
                    value: _vm.permissionStatus,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isInitialized
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.absences.type_absenses"),
                    value: _vm.detail.causeOfAbsenceDescription,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isInitialized
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.absences.start_date"),
                    value: _vm.detail.dateStart,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("formatted-date-component", {
                              attrs: { val: props.value, withTime: true },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3913778375
                  ),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.absences.end_date"),
                    value: _vm.detail.dateEnd,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("formatted-date-component", {
                              attrs: { val: props.value, withTime: true },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3913778375
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isInitialized && _vm.detail.comments
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("suc-text-form-show-field", {
                  attrs: {
                    title: _vm.$t("pages.permission.absences.comments"),
                    value: _vm.detail.comments,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.isInitialized
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "label-description" }, [
                  _vm._v(" " + _vm._s(_vm.$t("pages.permission.attachments"))),
                ]),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "description" },
                    _vm._l(_vm.detail.attachments, function (attachment) {
                      return _c(
                        "a",
                        {
                          key: attachment.key,
                          attrs: { target: "_blank", href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downLoadAttachment(attachment)
                            },
                          },
                        },
                        [_vm._v(_vm._s(attachment.name))]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.detail.canRemove()
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-right" },
              [
                _c("vue-button", {
                  staticClass: "btn-danger button my-1 mx-2",
                  attrs: { title: _vm.$t("components.actions.remove") },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.removeAbsence.apply(null, arguments)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body-icon",
                        fn: function () {
                          return [_c("i", { staticClass: "fas fa-trash-alt" })]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2110712871
                  ),
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }